import React, { useContext } from 'react';
import DashboardContext from '#/context';
import PropTypes from 'prop-types';
import styles from './styles.module.css';
import NotFound from '#/components/NotFound/index';
import Loader from '#/components/Loader/index';
import useWidget from '#/hooks/useWidget';
import renderCell from './renderCell'; 
import { FieldType } from './types';
import FloatingTooltipSticky from '#/components/FloatingTooltipSticky/index';

function DetailsTable({ dashboardWidgetId, endpoint, ordination, exhibition, widgetBindDtos, auxiliaryOptionsDto }) {
  const { filters, localFilters, date, polling } = useContext(DashboardContext);
  const { serviceData } = useWidget(
    endpoint,
    filters,
    localFilters,
    date,
    polling,
    dashboardWidgetId,
    ordination,
    exhibition,
    widgetBindDtos, 
    auxiliaryOptionsDto
  );

  const sortedColumns = (serviceData && serviceData.columns)
  ? [...serviceData.columns].sort(function (primary, second) {
      return (typeof primary.ordination === FieldType.NUMBER ? primary.ordination : 0)
           - (typeof second.ordination === FieldType.NUMBER ? second.ordination : 0);
    }) : [];

  const renderDetailsTable = () => (
    <div className={styles.wrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            {sortedColumns.map(column => (
              <th key={column.key}>
                  <span className={styles.spanEllipsis}>
                    <FloatingTooltipSticky content={column.title}>
                        <span className={styles.spanEllipsis}>{column.title}</span>
                    </FloatingTooltipSticky>
                  </span>
            </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {serviceData.rows.length ? (
            serviceData.rows.slice(0, exhibition || 100).map((item, index) => (
              <tr className={styles.tableRow} key={index}>
                {sortedColumns.map(column => (
                  <td key={column.key}>{renderCell(item, column, exhibition, index)}</td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={sortedColumns.length}><NotFound /></td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  return serviceData && serviceData.rows ? renderDetailsTable() : <Loader />;
}

DetailsTable.propTypes = {
  endpoint: PropTypes.shape({
    endpointType: PropTypes.string,
    endpointUrl: PropTypes.string,
  }),
};

export default DetailsTable
